import api from './apiConfig';

// apiConfig monta gia' `${API_URL}${API_BASE_PATH}`, cioe' /v1, come baseURL: i percorsi
// qui sono relativi a quello, come fa userAdminService.
const auditService = {
    listEvents: ({ categorie, q, da, a, pagina, dimensione } = {}) => {
        const params = {};
        if (categorie && categorie.length > 0) {
            params.categorie = categorie.join(',');
        }
        if (q) {
            params.q = q;
        }
        if (da) {
            params.da = da;
        }
        if (a) {
            params.a = a;
        }
        if (pagina !== undefined) {
            params.pagina = pagina;
        }
        if (dimensione !== undefined) {
            params.dimensione = dimensione;
        }
        return api.get('/audit', { params }).then((r) => r.data);
    },
    // responseType 'blob' cosi' un 422 si intercetta prima di aprire alcunche': un <a href>
    // diretto porterebbe il corpo dell'errore dentro un file .csv.
    exportEvents: ({ categorie, q, da, a } = {}) => {
        const params = {};
        if (categorie && categorie.length > 0) {
            params.categorie = categorie.join(',');
        }
        if (q) {
            params.q = q;
        }
        if (da) {
            params.da = da;
        }
        if (a) {
            params.a = a;
        }
        return api.get('/audit/export', { params, responseType: 'blob' });
    },
};

export default auditService;
